module.exports = __webpack_public_path__ + "media/cgae/rlogo-0f7ce48c.png";